if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.slider = null;
        this.thumbsSlider = null;
        this.isInteractingWithSlider = false;
        this.isMobile = window.innerWidth < 750;
        this.originalContent = null;
      }

      connectedCallback() {
        window.addEventListener('resize', this.handleResize.bind(this));
      }

      handleResize() {
        const wasMobile = this.isMobile;
        this.isMobile = window.innerWidth < 750;
        
        if (wasMobile !== this.isMobile && this.openedBy) {
          if (this.slider) {
            this.slider.destroy();
            this.slider = null;
          }
          if (this.thumbsSlider) {
            this.thumbsSlider.destroy();
            this.thumbsSlider = null;
          }
          this.showActiveMedia();
        }
      }

      hide() {
        if (!this.isInteractingWithSlider) {
          if (this.slider) {
            this.slider.destroy();
            this.slider = null;
          }
          if (this.thumbsSlider) {
            this.thumbsSlider.destroy();
            this.thumbsSlider = null;
          }
          // Restore original content if modified
          if (this.originalContent && this.querySelector('.product-media-modal__content')) {
            this.querySelector('.product-media-modal__content').innerHTML = this.originalContent;
            this.originalContent = null;
          }
          super.hide();
        }
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      initSlider(activeIndex) {
        const container = this.querySelector('.product-media-modal__content');
        
        // Save original content for mobile
        if (!this.originalContent) {
          this.originalContent = container.innerHTML;
        }
        
        const images = container.querySelectorAll('img, [data-media-id]');
        let slidesHTML = '';
        let thumbnailsHTML = '';
        
        images.forEach((img, index) => {
          // Get image source for both main slide and thumbnail
          let imgSrc = '';
          if (img.tagName === 'IMG') {
            imgSrc = img.src;
          } else {
            const nestedImg = img.querySelector('img');
            if (nestedImg) {
              imgSrc = nestedImg.src;
            }
          }
          
          slidesHTML += `<div class="glide__slide">${img.outerHTML}</div>`;
          
          // Add active class to the current thumbnail
          const activeClass = index === activeIndex ? 'active-thumbnail' : '';
          thumbnailsHTML += `
            <div class="glide__slide thumbnail-slide ${activeClass}">
              <img class="thumbnail-img" src="${imgSrc}" alt="Thumbnail ${index + 1}" loading="lazy">
            </div>
          `;
        });
        
        container.innerHTML = `
          <div class="modal-content-wrapper">
            <div class="main-slider">
              <div class="glide__track" data-glide-el="track">
                <div class="glide__slides">
                  ${slidesHTML}
                </div>
              </div>
              <div class="glide__arrows" data-glide-el="controls">
                <button class="glide__arrow glide__arrow--left" data-glide-dir="<">←</button>
                <button class="glide__arrow glide__arrow--right" data-glide-dir=">">→</button>
              </div>
            </div>
            
            <div class="thumbnails-container">
              <div class="thumbnails-slider">
                <div class="thumbnails-arrows">
                  <button class="thumbnail-arrow thumbnail-arrow--left" data-glide-dir="<">←</button>
                </div>
                <div class="glide" id="thumbnails">
                  <div class="glide__track" data-glide-el="track">
                    <div class="glide__slides">
                      ${thumbnailsHTML}
                    </div>
                  </div>
                </div>
                <div class="thumbnails-arrows">
                  <button class="thumbnail-arrow thumbnail-arrow--right" data-glide-dir=">">→</button>
                </div>
              </div>
            </div>
          </div>
        `;

        // Add custom styles for the thumbnails layout
        this.addCustomStyles();
        
        // Initialize main slider
        this.slider = new Glide('.main-slider', {
          type: 'slider',
          startAt: activeIndex,
          perView: 1,
          gap: 0,
          touchRatio: 0.5
        }).mount();
        
        // Initialize thumbnails slider
        this.thumbsSlider = new Glide('#thumbnails', {
          type: 'slider',
          startAt: activeIndex,
          perView: 8,
          gap: 10,
          breakpoints: {
            1200: { perView: 6 },
            900: { perView: 5 },
            750: { perView: 4 }
          }
        }).mount();
        
        // Setup thumbnail arrows
        const leftThumbArrow = container.querySelector('.thumbnail-arrow--left');
        const rightThumbArrow = container.querySelector('.thumbnail-arrow--right');
        
        leftThumbArrow.addEventListener('click', () => {
          this.thumbsSlider.go('<');
        });
        
        rightThumbArrow.addEventListener('click', () => {
          this.thumbsSlider.go('>');
        });
        
        // Sync sliders
        this.syncSliders();
        this.addSliderInteractionEvents();
      }
      
      addCustomStyles() {
        // If a style element already exists, don't add it again
        if (document.getElementById('product-modal-thumbnail-styles')) return;
        
        const styleElement = document.createElement('style');
        styleElement.id = 'product-modal-thumbnail-styles';
        styleElement.textContent = `
          .modal-content-wrapper {
            display: flex;
            flex-direction: column;
            height: 100%;
            width: 100%;
          }
          
          .main-slider {
            flex: 1;
            overflow: hidden;
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          
          .thumbnails-container {
            padding: 15px 0;
            background-color: #fff;
            position: relative;
            z-index: 10;
          }
          
          .thumbnails-slider {
            display: flex;
            align-items: center;
            padding: 0 20px;
            position: relative;
          }
          
          .thumbnails-arrows {
            display: flex;
            align-items: center;
            z-index: 2;
          }
          
          .thumbnail-arrow {
            background: rgba(0,0,0,0.5);
            color: white;
            border: none;
            width: 30px;
            height: 30px;
            border-radius: 50%;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 5px;
            z-index: 10;
          }
          
          .thumbnail-arrow:hover {
            background: rgba(0,0,0,0.8);
          }
          
          #thumbnails {
            flex: 1;
            margin: 0 10px;
            overflow: hidden;
          }
          
          .thumbnail-slide {
            cursor: pointer;
            padding: 2px;
            border: 2px solid transparent;
            transition: all 0.3s ease;
            opacity: 0.6;
          }
          
          .thumbnail-slide.active-thumbnail {
            border-color: #000;
            opacity: 1;
          }
          
          .thumbnail-img {
            width: 100%;
            height: 60px;
            object-fit: cover;
          }
          
          .thumbnail-slide:hover {
            opacity: 0.9;
          }
        `;
        
        document.head.appendChild(styleElement);
      }

      syncSliders() {
        // When main slider changes, update thumbnails
        this.slider.on('move', () => {
          const index = this.slider.index;
          this.thumbsSlider.go(`=${index}`);
          
          // Update active thumbnail styling
          const thumbnails = this.querySelectorAll('.thumbnail-slide');
          thumbnails.forEach((thumb, i) => {
            if (i === index) {
              thumb.classList.add('active-thumbnail');
            } else {
              thumb.classList.remove('active-thumbnail');
            }
          });
        });
        
        // When clicking on thumbnails, update main slider
        const thumbnails = this.querySelectorAll('.thumbnail-slide');
        thumbnails.forEach((thumb, i) => {
          thumb.addEventListener('click', () => {
            this.slider.go(`=${i}`);
          });
        });
      }

      addSliderInteractionEvents() {
        const container = this.querySelector('.product-media-modal__content');
        const arrows = container.querySelectorAll('.glide__arrow, .thumbnail-arrow');
        const mainTrack = container.querySelector('.main-slider .glide__track');
        const thumbsContainer = container.querySelector('.thumbnails-container');
        
        // Mark interaction with controls and slides
        arrows.forEach(arrow => {
          arrow.addEventListener('mousedown', () => {
            this.isInteractingWithSlider = true;
          });
          arrow.addEventListener('mouseup', () => {
            setTimeout(() => this.isInteractingWithSlider = false, 100);
          });
          arrow.addEventListener('touchstart', () => {
            this.isInteractingWithSlider = true;
          });
          arrow.addEventListener('touchend', () => {
            setTimeout(() => this.isInteractingWithSlider = false, 100);
          });
        });
        
        mainTrack.addEventListener('mousedown', () => {
          this.isInteractingWithSlider = true;
        });
        
        mainTrack.addEventListener('mouseup', () => {
          setTimeout(() => this.isInteractingWithSlider = false, 100);
        });
        
        thumbsContainer.addEventListener('mousedown', () => {
          this.isInteractingWithSlider = true;
        });
        
        thumbsContainer.addEventListener('mouseup', () => {
          setTimeout(() => this.isInteractingWithSlider = false, 100);
        });
        
        // Prevent modal from closing when clicking inside content
        container.addEventListener('click', (e) => {
          e.stopPropagation();
        });
      }

      showActiveMedia() {
        const activeMediaId = this.openedBy.getAttribute('data-media-id');
        const allMedia = Array.from(this.querySelectorAll('[data-media-id]'));
        const activeIndex = allMedia.findIndex(el => el.getAttribute('data-media-id') === activeMediaId);
        
        if (!this.isMobile) {
          // Desktop - use slider with thumbnails
          if (!this.slider) {
            this.initSlider(activeIndex);
          } else {
            this.slider.update({ startAt: activeIndex });
            this.thumbsSlider.update({ startAt: activeIndex });
            
            // Update active thumbnail styling
            const thumbnails = this.querySelectorAll('.thumbnail-slide');
            thumbnails.forEach((thumb, i) => {
              if (i === activeIndex) {
                thumb.classList.add('active-thumbnail');
              } else {
                thumb.classList.remove('active-thumbnail');
              }
            });
          }
        } else {
          // Mobile - use original zoom behavior
          const container = this.querySelector('.product-media-modal__content');
          
          // Restore original content if we previously used slider
          if (this.originalContent) {
            container.innerHTML = this.originalContent;
            this.originalContent = null;
          }
          
          // Activate the clicked media
          this.querySelectorAll('[data-media-id]').forEach((element) => {
            element.classList.remove('active');
          });
          
          const activeMedia = this.querySelector(`[data-media-id="${activeMediaId}"]`);
          if (activeMedia) {
            activeMedia.classList.add('active');
            activeMedia.scrollIntoView();
            
            // Handle deferred media (videos, etc.)
            const activeMediaTemplate = activeMedia.querySelector('template');
            const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
            
            if (activeMedia.nodeName == 'DEFERRED-MEDIA' && 
                activeMediaContent && 
                activeMediaContent.querySelector('.js-youtube')) {
              activeMedia.loadContent();
            }
          }
        }
      }
    }
  );
}